// extracted by mini-css-extract-plugin
export default {"topContainer":"DilemmaInput_topContainer__NWOiL","dilemmaCard":"DilemmaInput_dilemmaCard__H9+nx"};